import { clsx } from 'clsx';
import React from 'react';
import { BaseFieldProps, Field } from '../Field';

// TODO: Clean up these props. Do we need "as"?

type AdditionalProps = {
  error?: boolean;
  placeholder?: string;
};

type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  as?: any;
} & AdditionalProps;

export const Select: React.FC<SelectProps> = ({
  children,
  error,
  disabled,
  placeholder,
  value = '',
  className,
  ...props
}) => (
  <select
    {...props}
    value={value}
    className={clsx(
      'text-turf-green-500 h-10 w-full rounded border px-4 text-base outline-none transition duration-200 focus:outline-none focus:ring',
      {
        'border-red-500 bg-white ring-red-500 ring-opacity-30': error,
        'bg-white focus:border-green-500': !error,
        'bg-off-white-500 text-slate-green-500 cursor-not-allowed': disabled,
      },
      className,
    )}
    disabled={disabled}
  >
    {placeholder && (
      <option value="" disabled>
        {placeholder}
      </option>
    )}
    {children}
  </select>
);

type SelectFieldProps = React.SelectHTMLAttributes<HTMLSelectElement> &
  BaseFieldProps & {
    placeholder?: string;
  };

export const SelectField: React.FC<SelectFieldProps> = ({
  children,
  containerClassName,
  id,
  error,
  label,
  labelClassName,
  hint,
  name,
  placeholder,
  ...props
}) => (
  <Field
    name={name}
    id={id || name}
    label={label}
    hint={hint}
    error={error}
    labelClassName={labelClassName}
    containerClassName={containerClassName}
  >
    <Select
      id={id || name}
      name={name}
      error={!!error}
      placeholder={placeholder}
      {...props}
    >
      {children}
    </Select>
  </Field>
);
